import type { DiagnosticsSessionSnapshot } from "#diagnostics-types";

// Web keeps everything in memory: a multi-megabyte session snapshot does not belong in
// localStorage, and OPFS is already owned by the database leader worker. A crashed tab loses its
// tail; the report still carries the live session.
export function rotateDiagnosticsSessionFile(): void {}

export function writeDiagnosticsSessionFile(_snapshot: DiagnosticsSessionSnapshot): void {}

export function readPreviousDiagnosticsSession(): DiagnosticsSessionSnapshot | null {
  return null;
}

export function clearDiagnosticsSessionFiles(): void {}

export function writeDiagnosticsReportFile(_fileName: string, _json: string): string {
  throw new Error(
    "Diagnostic report files are not written to disk on web; use the download instead.",
  );
}
